// @ts-nocheck
/* eslint-disable */
import { CONFIG, Scene, store } from "./globals";
import GPSSWitchVisualizer from "~/ui/gpsswitch/visualizer";
import { _ } from "~/i18n";
import { setCoordinates } from "~/state/map/state";
import { getLocation } from "~/whereami";
import { icon, node } from "~/util/dom";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";
import { WASM_ZINDEX } from "~/wasm/const";
import WasmBulkMode from "~/wasm/store/bulk-mode";
import { IWasmStoreMarker } from "~/wasm/store/interfaces";

/**
 * Jeden radek - jeden item vlastnich bodu + jeho marker v mape.
 */
export default class Item {
	_wasmMarker: WasmStoreMarker;

	/**
	 * Item.
	 *
	 * @param  {UserMarks} owner Instance rodice
	 * @param {SceneCoords} coords Souradnice
	 * @param {String} label Titulek
	 * @param {String} desc Popisek
	 */
	constructor(owner, coords, label, desc) {
		this._owner = owner;
		this._coords = coords;
		this._label = label;
		this._desc = desc;
		this._layers = owner.layers;
		this._index = -1;
		this._dom = {};
		this._gpsVis = new GPSSWitchVisualizer();
		this._gpsVis.setCoords(coords);
		this._marker = this._createMarker();
		this._wasmMarker = null;
		this._sl = [];
		this._unSaved = false;
		this._visibleEdit = false;

		this._build();
		this._showEdit();

		this._sl.push(Scene.addListener("marker-drag-move", "_dragMove", this, this._marker));
		this._sl.push(Scene.addListener("marker-drag-stop", "dragStop", this, this._marker));
	}

	/**
	 * Odstraneni.
	 */
	destroy(wasmBulk?: WasmBulkMode) {
		this._showEdit();
		Scene.removeListeners(this._sl);
		this._gpsVis.destroy();
		this._owner.sectionHighlight(false, this._index);
		this._dom.container.remove();
		this._layers.markers.removeMarker(this._marker);
		this.destroyWasmMarker(wasmBulk);
	}

	/**
	 * Ziskani obalu - jeden radek seznamu.
	 *
	 * @return {Element}
	 */
	get container() {
		return this._dom.container;
	}

	/**
	 * Data.
	 *
	 * @return {Object}
	 */
	get data() {
		return {
			label: this._label,
			desc: this._desc,
			coords: this._coords
		};
	}

	/**
	 * Nastaveni indexu - pozice itemu.
	 *
	 * @param  {Number} index Pozice
	 */
	set index(index) {
		if (index != this._index) {
			this._index = index;

			this._dom.markerNum.textContent = index + 1;
			this._dom.markerImgNum.textContent = index + 1;
			this._marker.updateM3dData({ index: index + 1 });
		}
	}

	/**
	 * Vraceni indexu.
	 *
	 * @return  {Number}
	 */
	get index() {
		return this._index;
	}

	/**
	 * Nastaveni titulku.
	 *
	 * @param  {String} label Titulek
	 */
	set label(label) {
		this._label = label;
		this._dom.title.textContent = label;
		this._dom.title.title = this._dom.title.textContent;
	}

	/**
	 * Ziskani souradnic - start.
	 *
	 * @return {SceneCoords}
	 */
	getCoords() {
		return this._coords;
	}

	get wasmMarker() {
		return this._wasmMarker;
	}

	/**
	 * Nastaveni hoveru.
	 *
	 * @param {Boolean} isEnter Jedna se o vstup?
	 * @param {Boolean} isActive Aktivni ano/ne
	 */
	setHover(isEnter, isActive, wasmBulk?: WasmBulkMode) {
		let wasmUpdate: Partial<IWasmStoreMarker> = {};

		if (isEnter) {
			this._dom.container.classList.remove("active");
			this._marker.setActive(false);

			if (isActive) {
				this._dom.container.classList.add("active");
				this._marker.setActive(true);
			}

			wasmUpdate = {
				visual: isActive
					? "standard"
					: "inactive",
				bringToTheFront: isActive,
			};
		} else {
			this._dom.container.classList.remove("active");
			this._marker.setActive(true);

			wasmUpdate = {
				visual: "standard",
				bringToTheFront: false,
			};
		}

		if (wasmBulk) {
			wasmBulk.updateMarker(this._wasmMarker, wasmUpdate);
		} else {
			this._wasmMarker.update(wasmUpdate);
		}
	}

	/**
	 * Nastaveni stavu itemu, kdy byl pridan pres klik do mapy.
	 */
	addFromMap() {
		this._unSaved = true;
		this._showEdit(true);
	}

	/**
	 * Manualni zavreni editacniho modu.
	 */
	editClose() {
		if (this._unSaved) {
			this._save();
		}
		else {
			this._showEdit();
		}
	}

	readOnly(readOnly) {
		this._cancel();
		this._owner.noAnimEnd();
	}

	/**
	 * Veskera interakce nad body - tahani, presuny...
	 *
	 * @param  {Event} e
	 */
	handleEvent(e) {
		switch (e.type) {
			case "click":
				if (CONFIG.inFrame) {
					Mapy.Util.openInNewWindow();
				}
				else if (this._dom.saveBtn.contains(e.target)) {
					e.stopPropagation();
					this._save();
					this._owner.noAnimEnd();
				} else if (this._dom.cancelBtn.contains(e.target)) {
					e.stopPropagation();
					this._cancel();
					this._owner.noAnimEnd();
				} else if (this._dom.editBtn.contains(e.target)) {
					e.stopPropagation();
					this._showEdit(true);
				} else if (this._dom.removeBtn.contains(e.target)) {
					e.stopPropagation();
					this._owner.remove(this._index);
					Mapy.getComponent("history").save();
				} else if (this._dom.container.contains(e.target) && e.target.tagName.toLowerCase() != "input") {
					const [longitude, latitude] = this._coords.toWGS84();

					store.dispatch(setCoordinates({
						longitude,
						latitude,
						animate: true,
					}));
					Mapy.getComponent("history").save();
				} else {
					e.stopPropagation();
					if (!this._owner.editItem) {
						this._dom.container.scrollIntoView(false);
					}
				}
				break;

			case "mouseenter":
				this._owner.sectionHighlight(true, this._index);
				break;

			case "mouseleave":
				this._owner.sectionHighlight(false, this._index);
				break;

			case "keydown":
				let keyCode = e.which || e.keyCode;

				if (keyCode == 27) {
					this._cancel();
					this._owner.noAnimEnd();
				}
				else if (keyCode == 13 && e.target == this._dom.titleInput) {
					this._save();
					this._owner.noAnimEnd();
				}
				break;
		}
	}

	createWasmMarker(wasmBulk?: WasmBulkMode) {
		if (!this._wasmMarker) {
			const wasmMarkerConfig: Partial<IWasmStoreMarker> = {
				type: "user-marks",
				lon: this._coords.x,
				lat: this._coords.y,
				draggable: true,
				zIndex: WASM_ZINDEX.marker.userMarks,
				customData: {
					order: this._index + 1,
				},
				interactionType: "click-hover",
			};

			if (wasmBulk) {
				this._wasmMarker = wasmBulk.createMarker(wasmMarkerConfig);
			} else {
				this._wasmMarker = new WasmStoreMarker(wasmMarkerConfig);
			}
		}
	}

	destroyWasmMarker(wasmBulk?: WasmBulkMode) {
		if (wasmBulk) {
			wasmBulk.removeMarker(this._wasmMarker);
		} else {
			this._wasmMarker?.destroy();
		}

		this._wasmMarker = null;
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_build() {
		let li = node("li", { className: "item" });

		// leva cast
		let markerImgCont = node("div", { className: "marker-cont" });
		let markerImgNum = node("span", {className: "text", textContent: this._index });
		let marker = this._createMarkerImg(markerImgNum);
		markerImgCont.appendChild(marker);

		// prava cast
		let viewCont = node("div", { className: "view-cont" });
		// detail vypisu
		let title = node("h2", { className: "title", textContent: this._label });
		title.title = title.textContent;
		let titleInput = node("input", { className: "title-input", value: this._label });
		let desc = node("p", { className: "desc", textContent: this._desc });
		let modules = node("div", { className: "modules" });
		modules.appendChild(this._gpsVis.getContainer());
		let buttons = node("div", { className: "buttons" });
		let saveBtn = node("button", { className: "save-btn", textContent: _("save") });
		let cancelBtn = node("button", { className: "cancel-btn", textContent: _("cancel") });
		buttons.appendChild(saveBtn);
		buttons.appendChild(cancelBtn);
		// editace
		let editCont = node("div", { className: "edit-cont" });
		let editBtn = node("button", { className: "edit-btn", textContent: _("edit") });
		let removeBtn = node("button", { className: "remove-btn" });
		removeBtn.appendChild(icon("delete"));
		editCont.appendChild(editBtn);
		editCont.appendChild(removeBtn);

		viewCont.appendChild(title);
		viewCont.appendChild(titleInput);
		viewCont.appendChild(desc);
		viewCont.appendChild(modules);
		viewCont.appendChild(buttons);
		viewCont.appendChild(editCont);
		viewCont.appendChild(node("div", { className: "separator" }));

		li.appendChild(icon("move"));
		li.appendChild(markerImgCont);
		li.appendChild(viewCont);

		saveBtn.addEventListener("click", this);
		cancelBtn.addEventListener("click", this);
		editCont.addEventListener("click", this);
		removeBtn.addEventListener("click", this);

		li.addEventListener("click", this);
		li.addEventListener("mouseenter", this);
		li.addEventListener("mouseleave", this);

		this._dom.container = li;
		this._dom.markerImgCont = markerImgCont;
		this._dom.title = title;
		this._dom.desc = desc;
		this._dom.markerImgNum = markerImgNum;
		this._dom.titleInput = titleInput;
		this._dom.buttons = buttons;
		this._dom.saveBtn = saveBtn;
		this._dom.cancelBtn = cancelBtn;
		this._dom.editBtn = editBtn;
		this._dom.removeBtn = removeBtn;

		// pridame do rodice
		this._owner.itemsContainer.appendChild(li);
	}

	/**
	 * Vytvoreni markeru jako obrazku pro jeden item.
	 *
	 * @param  {Element} elm Vlastni element pro zobrazeni pozice
	 * @return {Element}
	 */
	_createMarkerImg(elm) {
		let cont = node("a", { className: "marker type-small" });
		let before = node("span", { className: "before" });
		let wrapper = node("span", { className: "marker-bg-wrapper" });
		let shadow = node("img", {
			src: `${CONFIG.apiUrl}/img/api/wmmarker/small.png`,
			srcset: `${CONFIG.apiUrl}/img/api/wmmarker/small.png 1x, ${CONFIG.apiUrl}/img/api/wmmarker/small@2x.png 2x, ${CONFIG.apiUrl}/img/api/wmmarker/small@3x.png 3x`,
			crossOrigin: "anonymous",
		});
		let marker = shadow.cloneNode();

		before.appendChild(shadow);
		wrapper.appendChild(marker);
		cont.appendChild(before);
		cont.appendChild(wrapper);
		cont.appendChild(elm);

		return cont;
	}

	/**
	 * Zobrazeni/skryti editace.
	 *
	 * @param  {Boolean} state
	 */
	_showEdit(state) {
		if (state == this._visibleEdit) return;

		this._dom.container.classList[state ? "add" : "remove"]("edit-mode");
		this._gpsVis.setVisualization(state ? "select" : "");

		if (state) {
			this._dom.titleInput.value = this._label;
			if (Mapy.getComponent("layout").getWidth() > 0) {
				this._dom.titleInput.focus();
				setTimeout(() => {
					this._dom.container.scrollIntoView(false);
				}, 0);
			}
			document.addEventListener("keydown", this);
		}
		else {
			document.removeEventListener("keydown", this);
		}

		this._visibleEdit = state;
		this._owner.editItem = state ? this : null;

		if (state) {
			this._owner.noAnimStart();
		}
	}

	/**
	 * Vytvoreni markeru pro mapu.
	 *
	 * @return {SceneMarker}
	 */
	_createMarker() {
		let markerNum = node("span", {className: "text", textContent: this._index + 1 });
		let marker = Scene.createMarkerWindy(this._coords, null, {
			type: this._owner.showMarkerLabel ? Scene.VISUAL.MARKER_WINDY.LITTLE : Scene.VISUAL.MARKER_WINDY.SMALL,
			elm: this._owner.showMarkerLabel ? null : markerNum,
			// data pro 3d
			m3dData: {
				type: "userMarks",
				index: this._index + 1,
				enter: () => {
					this._owner.sectionHighlight(true, this._index);
				},
				leave: () => {
					this._owner.sectionHighlight(false, this._index);
				}
			}
		});

		let cont = marker.getContainerSync() || document.createElement("div");

		if (!CONFIG.inFrame) {
			cont.addEventListener("mouseenter", this);
			cont.addEventListener("mouseleave", this);
		}

		cont.addEventListener("click", this);

		this._dom.marker = cont;
		this._dom.markerNum = markerNum;
		if (!CONFIG.inFrame) {
			marker.decorateDraggable();
		}

		this._layers.markers.addMarker(marker);

		if (CONFIG.inFrame && this._owner.showMarkerLabel) {
			marker.setLabel(this._label);
		}

		return marker;
	}

	/**
	 * Presun markeru na mape.
	 *
	 * @param  {Object} e
	 */
	_dragMove(e) {
		this._coords = e.data.coords;
		this._gpsVis.setCoords(this._coords);
	}

	dragMove(longitude, latitude) {
		this._coords = Scene.coordsFromWGS84(longitude, latitude);
		this._gpsVis.setCoords(this._coords);
	}

	/**
	 * Presun markeru na mape - konec.
	 *
	 * @param  {Object} e
	 */
	dragStop() {
		this._setWhereamiDesc();
		Mapy.getComponent("logger").log("points", { end_points: "point-moved", count: this._owner.getItems().length });
	}

	/**
	 * Ulozeni dat itemu.
	 */
	_save() {
		if (this._unSaved) {
			this._setWhereamiDesc();
		}

		let value = this._dom.titleInput.value.trim();

		if (value && this._label != value) {
			this.label = value;
			Mapy.getComponent("history").save(true);
		}

		if (!this._unSaved) {
			this._owner.itemUpdate(this._index);
		}

		this._showEdit();
		this._unSaved = false;
	}

	/**
	 * Zruseni uprav.
	 */
	_cancel() {
		if (this._unSaved) {
			this._owner.remove(this._index);
			this._owner.editItem = null;
			this._owner.sectionHighlight(false, this._index);
		}
		else {
			this._showEdit();
		}
	}

	/**
	 * Nastaveni popisku pres whereami.
	 */
	_setWhereamiDesc() {
		getLocation(this._coords).then(data => {
			this._desc = data.label;
			this._dom.desc.textContent = this._desc;
			this._owner.itemUpdate(this._index);
		}, e => {
			Mapy.getComponent("history").save(true);
		});
	}
}
